module.exports = __webpack_public_path__ + "static/david-c4dc2e253d2793c82dc6f5c4626ff968.png";